import React, { useContext, useEffect, useState } from 'react'
import { Redirect, Route, NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { useChatContext } from 'stream-chat-react'
import { AuthContext } from '../../../../auth-context'
import { DashboardContext } from '../../dashboard-context'
import { inspectPortalAccount, getPortalAccountTrackerData, getPortalAccountWeighInDetails, getCheckIns, getOrCreatePortalChannel } from '../../../../api'
import { mdInitial, mdFetchUserFulfilled, mdFetchWeighInDetails, mdFetchWeighInDetailsFulfilled } from './macro-data'
import { todayString } from './util'
import CircularProgress from '@material-ui/core/CircularProgress'
import Icon from '@material-ui/core/Icon'
import Profile from './components/profile'
import Timeline from './components/timeline'
import Notes from './components/notes'
import EditAccount from './components/edit-account'
import Tracker from './components/tracker/tracker'
import Exercise from './components/exercise'
import AddNoteModal from '../../views/inspect/components/add-notes'
import EditNoteModal from '../../views/inspect/components/edit-notes'
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import { ThemeContext } from 'styled-components'
import '../../../../css/inspect.sass'
import { canInspectNutrition as hasNutritionInspectionAccess } from './inspection-access'
import { hasExerciseAccess } from '../../../../feature-access'

const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 200px 0px;
  width: 100%;
`;

const Content = styled.div`
  margin: 0 auto;
  padding: 0 0px;

  @media(max-width: 900px) {
    padding: 0 8px;
  }
`;

const SideLink = styled(NavLink)`
  &.active {
    color: ${(props) => props.theme.color.primary} !important;
    span {
      color: ${(props) => props.theme.color.primary} !important;
    }
  }
`;

const Message = styled.div`
  // width: 100%;
  // padding: 24px;

  // @media(max-width: 900px) {
  //   padding: 16px;
  // }
  color: #595959;
  font-weight: 400;
  margin-top: 32px;
`;

const ChatLink = styled.div`
  display: flex;
  align-items: center;
  padding: 0 6px;
  font-size: 0.9rem;
  font-weight: 500;
  padding-bottom: 2px;
  margin-right: 16px;
  cursor: pointer;
`;

const Inspect = (props) => {
  const theme = useContext(ThemeContext)
  const useStyles = makeStyles(materialTheme=> ({
    buttonProgress: {
      color: theme.color.primary,
    },
  }));

  const classes = useStyles();
  const { user } = useContext(AuthContext)
  const { client, setActiveChannel } = useChatContext()
  const { setShowMessages, setMessageChannel, openSnackbar } = useContext(DashboardContext)
  const [loadedAccountId, updateLoadedAccountId] = useState(0)
  const [loadedAccount, updateLoadedAccount] = useState({loading: false, updateNotes: false})
  const [loadedMacroData, updateLoadedMacroData] = useState(mdInitial)
  const [trackerData, updateTrackerData] = useState({selectedGraphDate: todayString(), selectedTrackerDate: todayString(), timeline: {}, showConsumedMacros: true, loading: false})
  const [loading, updateLoading] = useState(false)
  const accountId = Number(props.match.params.id)
  const portalAccount = (user.accounts || []).find((account) => Number(account.id) === accountId)
  const inspectedClientName = (portalAccount && portalAccount.name) || (loadedAccount.user && loadedAccount.user.full_name) || ''
  const inspectedClientEmail = (portalAccount && portalAccount.email_address) || (loadedAccount.user && loadedAccount.user.email_address) || ''
  const hasExercise = hasExerciseAccess(user, portalAccount)
  const canInspectNutrition = hasNutritionInspectionAccess(portalAccount)
  const isExerciseRoute = props.location.pathname.endsWith('/exercise')

  useEffect(() => {
    if(isExerciseRoute) {
      return
    }

    if(!canInspectNutrition) {
      if(hasExercise) {
        props.history.replace('/dashboard/inspect/' + accountId + '/exercise')
      } else {
        props.history.replace('/dashboard/accounts')
      }
      return
    }

    if(!loading) {
      if(loadedAccountId !== accountId) {
        updateLoading(true)
        inspectPortalAccount(user.id, accountId).then((res) => {
          updateLoadedMacroData(mdFetchUserFulfilled(mdInitial, res.data.user, res.data.timeline))
          updateLoadedAccount(res.data)
          updateLoadedAccountId(accountId)
          updateLoading(false)
        })
      }
    }
  }, [accountId, canInspectNutrition, hasExercise, isExerciseRoute, loadedAccountId, loading, props.history, user.id])

  useEffect(() => {
    if(loadedAccount.user) {
      let newAccount = _.cloneDeep(loadedAccount);
      getCheckIns(user.id, accountId, newAccount.user.id).then((res) => {
        newAccount.user.weighins = res.data.check_ins
        updateLoadedAccount(newAccount)
      })
    }
  }, [loadedAccountId])

  const loadPortalAccount = () => {
    let newAccount
    inspectPortalAccount(user.id, accountId).then((res) => {
      updateLoadedMacroData(mdFetchUserFulfilled(mdInitial, res.data.user, res.data.timeline))
      newAccount = _.cloneDeep(res.data)
      updateLoading(false)
    }).then(() => {
      getCheckIns(user.id, accountId, newAccount.user.id).then((res) => {
        newAccount.user.weighins = res.data.check_ins
        updateLoadedAccount(newAccount)
      })
    })
  }

  const selectDate = (newDate) => {
    updateTrackerData(Object.assign({}, trackerData, {selectedTrackerDate: newDate}))
  }

  const selectGraphDate = (newDate) => {
    updateTrackerData(Object.assign({}, trackerData, {selectedGraphDate: newDate}))
  }


  const setShowConsumedMacros = (value) => {
    updateTrackerData(Object.assign({}, trackerData, {showConsumedMacros: value}))
  }

  const setUpdateNotes = (value) => {
    inspectPortalAccount(user.id, accountId).then((res) => {
      updateLoadedAccount(Object.assign({}, res.data, {updateNotes: value}))
      updateLoading(false)
    })
  }

  const handleMessage = async () => {
    const getId = await getOrCreatePortalChannel(user.id, loadedAccount.user.id)
    const channelId = getId?.data?.result?.channel_id

    if (!channelId) {
      if (loadedAccount.user.linked_portal_id) {
        openSnackbar(`This user is a coach account for ${loadedAccount.user.linked_portal_name}.`, true)
      } else {
        openSnackbar('This user must sign in before messaging is available.', true)
      }
    } else {
      const filter = { id: channelId }
      const sort = { last_message_at: -1 }
      const options = { watch: true, state: true }
      const getChannel = await client.queryChannels(filter, sort, options)
      setActiveChannel(getChannel[0])
      setShowMessages(true)
      setMessageChannel(getChannel[0])
    }
  }

  const renderTracker = () => {
    let loadingTrackerData = false
    if(trackerData.loading) {
      loadingTrackerData = true
    } else if(!(trackerData.selectedTrackerDate in trackerData.timeline)) {
      updateTrackerData(Object.assign({}, trackerData, {loading: true}))
      loadingTrackerData = true
      getPortalAccountTrackerData(user.id, accountId, trackerData.selectedTrackerDate).then((res) => {
        updateTrackerData(Object.assign({}, trackerData, {timeline: Object.assign({}, trackerData.timeline, res.data), loading: false}))
      })
    }
    let relatedWeighInDateString = null
    let relatedWeighInDetails = null
    for(let key in loadedMacroData.weighInDetails) {
      if(key <= trackerData.selectedTrackerDate && (relatedWeighInDateString === null || key > relatedWeighInDateString)) {
        relatedWeighInDateString = key
      }
    }
    if(relatedWeighInDateString !== null) {
      relatedWeighInDetails = loadedMacroData.weighInDetails[relatedWeighInDateString]
      if(relatedWeighInDetails.level === 1) {
        loadingTrackerData = true
      } else if(relatedWeighInDetails.level === 0) {
        updateLoadedMacroData(mdFetchWeighInDetails(loadedMacroData, relatedWeighInDateString))
        loadingTrackerData = true
        getPortalAccountWeighInDetails(user.id, accountId, relatedWeighInDateString).then((res) => {
          updateLoadedMacroData(mdFetchWeighInDetailsFulfilled(loadedMacroData, res.data))
        })
      }
    }
    return loadingTrackerData ?
      <LoadingWrapper>
        <CircularProgress className={classes.buttonProgress} size={64}/>
        <Message>
          Loading tracker data...
        </Message>
      </LoadingWrapper>
    :
      <Tracker account={loadedAccount} macroData={loadedMacroData} trackerData={trackerData} relatedWeighInDateString={relatedWeighInDateString} selectDate={selectDate} setShowConsumedMacros={setShowConsumedMacros} />
  }

  const renderProfilePage = () => {
    let loadingTrackerData = false
    if(trackerData.loading) {
      loadingTrackerData = true
    } else if(!(trackerData.selectedTrackerDate in trackerData.timeline)) {
      updateTrackerData(Object.assign({}, trackerData, {loading: true}))
      loadingTrackerData = true
      getPortalAccountTrackerData(user.id, accountId, trackerData.selectedTrackerDate).then((res) => {
        updateTrackerData(Object.assign({}, trackerData, {timeline: Object.assign({}, trackerData.timeline, res.data), loading: false}))
      })
    }
    let relatedWeighInDateString = null
    let relatedWeighInDetails = null
    for(let key in loadedMacroData.weighInDetails) {
      if(key <= trackerData.selectedGraphDate && (relatedWeighInDateString === null || key > relatedWeighInDateString)) {
        relatedWeighInDateString = key
      }
    }
    if(relatedWeighInDateString !== null) {
      relatedWeighInDetails = loadedMacroData.weighInDetails[relatedWeighInDateString]
      if(relatedWeighInDetails.level === 1) {
        loadingTrackerData = true
      } else if(relatedWeighInDetails.level === 0) {
        updateLoadedMacroData(mdFetchWeighInDetails(loadedMacroData, relatedWeighInDateString))
        loadingTrackerData = true
        getPortalAccountWeighInDetails(user.id, accountId, relatedWeighInDateString).then((res) => {
          updateLoadedMacroData(mdFetchWeighInDetailsFulfilled(loadedMacroData, res.data))
        })
      }
    }
    return <Profile accountId={loadedAccountId} account={loadedAccount} macroData={loadedMacroData} trackerData={trackerData} loadingTrackerData={loadingTrackerData} relatedWeighInDateString={relatedWeighInDateString} selectGraphDate={selectGraphDate} setShowConsumedMacros={setShowConsumedMacros} getMacroData={getMacroData} loadPortalAccount={loadPortalAccount} openSnackbar={openSnackbar} portalUserId={user.id} portalOwnerId={user.owner_id}/>
  }

  const getMacroData = (dateString) => {
    if(loadedMacroData.weighInDetails) {
      if (loadedMacroData.weighInDetails[dateString].level === 0) {
        getPortalAccountWeighInDetails(user.id, accountId, dateString).then((res) => {
          updateLoadedMacroData(mdFetchWeighInDetailsFulfilled(loadedMacroData, res.data))
        })
      }
    }
  }


  // const renderNotes = () => {
  //   let loadingNoteData = false
  //   if(loadedAccount.loading) {
  //     loadingNoteData = true
  //   } else if(!(loadedAccount.trainerNotes !== )) {
  //     loadingNoteData = true
  //   }
  //   return loadingNoteData ?
  //     <LoadingWrapper>
  //       <CircularProgress size={64}/>
  //       <Message>Loading note data...</Message>
  //     </LoadingWrapper>
  //   :
  //     <Notes account={loadedAccount} updateNotes={updateNotes} />
  // }


  return (
    <Content>
      {(loading || (!isExerciseRoute && loadedAccountId !== accountId)) ?
        <LoadingWrapper>
          <CircularProgress className={classes.buttonProgress} size={64}/>
          <Message>
            Loading portal account...
          </Message>
        </LoadingWrapper>
      :
        <div className="inspect-dashboard">
          <div className="sidebar-mobile">
            {canInspectNutrition && <SideLink to={'/dashboard/inspect/' + accountId + '/overview'}><Icon>vertical_split</Icon></SideLink>}
            {canInspectNutrition && <SideLink to={'/dashboard/inspect/' + accountId + '/timeline'}><Icon>timeline</Icon></SideLink>}
            {canInspectNutrition && <SideLink to={'/dashboard/inspect/' + accountId + '/notes'}><Icon>note</Icon></SideLink>}
            {canInspectNutrition && <SideLink to={'/dashboard/inspect/' + accountId + '/edit'}><Icon>edit</Icon></SideLink>}
            {canInspectNutrition && <SideLink to={'/dashboard/inspect/' + accountId + '/tracker'}><Icon>fastfood</Icon></SideLink>}
            {canInspectNutrition && <ChatLink className="open-chat-button" onClick={handleMessage}><Icon>message</Icon></ChatLink>}
            {hasExercise && <SideLink className="exercise-link" to={'/dashboard/inspect/' + accountId + '/exercise'}><Icon>fitness_center</Icon></SideLink>}
          </div>
          <div className="inspect-nav" style={{'--inspect-primary-color': theme.color.primary}}>
            <div className="inspect-client-heading">
              <div className="inspect-client-label">Currently inspecting</div>
              <div className="inspect-client-name">{inspectedClientName}</div>
              <div className="inspect-client-email">{inspectedClientEmail}</div>
            </div>
            <div className="inspect-nav-actions">
              {canInspectNutrition && <ChatLink className="open-chat-button" onClick={handleMessage}><Icon>message</Icon>Open Chat</ChatLink>}
              {hasExercise && <SideLink className="exercise-link" to={'/dashboard/inspect/' + accountId + '/exercise'}><Icon>fitness_center</Icon>Exercise</SideLink>}
            </div>
            <div className="inspect-nav-tabs">
              {canInspectNutrition && <SideLink to={'/dashboard/inspect/' + accountId + '/overview'}>Profile</SideLink>}
              {canInspectNutrition && <SideLink to={'/dashboard/inspect/' + accountId + '/timeline'}>Timeline</SideLink>}
              {canInspectNutrition && <SideLink to={'/dashboard/inspect/' + accountId + '/notes'}>Trainer Notes</SideLink>}
              {canInspectNutrition && <SideLink to={'/dashboard/inspect/' + accountId + '/edit'}>Edit Account</SideLink>}
              {canInspectNutrition && <SideLink to={'/dashboard/inspect/' + accountId + '/tracker'}>Tracker</SideLink>}
            </div>
          </div>

          <div className="inspect-page">
            <Route path={'/dashboard/inspect/' + accountId + '/overview'} render={renderProfilePage}/>
            <Route path={'/dashboard/inspect/' + accountId + '/timeline'} render={() => <Timeline accountId={loadedAccountId} account={loadedAccount} macroData={loadedMacroData} getMacroData={getMacroData} />} />
            <Route path={'/dashboard/inspect/' + accountId + '/notes'} render={() => <Notes userId={user.id} account={loadedAccount} setUpdateNotes={setUpdateNotes}/>} />
            <Route path={'/dashboard/inspect/' + accountId + '/edit'} render={() => <EditAccount account={loadedAccount} macroData={loadedMacroData} trackerData={trackerData} loadPortalAccount={loadPortalAccount} getMacroData={getMacroData} />} />
            {/* <Route path={'/dashboard/inspect/' + accountId + '/edit'} render={renderEditAccount} /> */}
            {/* <Route path={'/dashboard/inspect/' + accountId + '/account'} render={() => <AccountDetails account={loadedAccount} macroData={loadedMacroData} trackerData={trackerData}  />} /> */}
            <Route path={'/dashboard/inspect/' + accountId + '/tracker'} render={renderTracker} />
            <Route path={'/dashboard/inspect/' + accountId + '/exercise'} render={() => hasExercise
              ? <Exercise managerId={user.id} accountId={accountId} />
              : <Redirect to={'/dashboard/inspect/' + accountId + '/overview'} />
            } />
          </div>
          {canInspectNutrition && loadedAccount.user && <AddNoteModal account={loadedAccount} user={user} setUpdateNotes={setUpdateNotes}/>}
          {canInspectNutrition && loadedAccount.user && <EditNoteModal account={loadedAccount} user={user} setUpdateNotes={setUpdateNotes}/>}
        </div>
      }
    </Content>
  )
}

export default Inspect
